define(['jquery',
        'core/urls',
        'core/dynamic-forms'],
    function($, urls) {

        function freshworksConnectivityCheck(instance){
            $.ajax({
                type: 'GET',
                url: urls['ticketsource:'+ instance +'-connectivity'](),
                dataType: 'json',
                success: function(data){
                    if(data.status === 'connected'){
                        $('#connectivity-status-checking-'+ instance +'').hide();
                        $('#connectivity-status-'+ instance +' p').hide();
                        $('#connectivity-status-connected-'+ instance +'').show();
                        $('#connectivity-status-notconnected-'+ instance +'').hide();
                    } else if(data.status === 'disconnected') {
                        $('#connectivity-status-checking-'+ instance +'').hide();
                        $('#connectivity-status-notconnected-'+ instance +'').show();
                        $('#connectivity-status-connected-'+ instance +'').hide();
                        $('#connectivity-status-'+ instance +' p').show();
                    }
                }
            });
        }

        return {
            'init': function() {
                $('#unhideFreshsalesInputButton').on('click', function () {
                    $('#unhideFreshsalesInputButtonContainer').hide();
                    $('#freshsalesInputContainer').collapse('show');
                });
                $(document).on('valid', 'form', function() {
                    if(!globals.has_generated_snippet) {
                        $('#continueToSurveyButton').prop('disabled', false);
                        $('#skipApiSetupLink').hide();
                    }
                });

                freshworksConnectivityCheck('freshdesk');
                freshworksConnectivityCheck('freshsales');

                $(document).on("valid", "#freshdesk-form", function(){
                    freshworksConnectivityCheck('freshdesk');
                });

                $(document).on("valid", "#freshsales-form", function(){
                    freshworksConnectivityCheck('freshsales');
                });
            }
        };
    }
);
